import { render, staticRenderFns } from "./Wizard.vue?vue&type=template&id=45e65fac&scoped=true&"
import script from "./Wizard.vue?vue&type=script&lang=ts&"
export * from "./Wizard.vue?vue&type=script&lang=ts&"
import style0 from "./Wizard.vue?vue&type=style&index=0&id=45e65fac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e65fac",
  null
  
)

export default component.exports